<template>
  <div>
    <router-view></router-view>
    <!-- <aboutus></aboutus> -->
  </div>
</template>

<script>
import Aboutus from './Aboutus';
export default {
  components: {
    Aboutus
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/open/panels/aboutus/AboutusContainer.vue